import { SuperAdminConstants } from '../../../_constants';

const initialState = { editReviewQuestionsLoading: true, data: '', error: false };

export function editReviewQuestionsReducer(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_EDIT_REVIEW_QUESTIONS:
            return {
                editReviewQuestionsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_EDIT_REVIEW_QUESTIONS:
            return {
                editReviewQuestionsLoading: false,
                data: action.editReviewQuestions,
                error: false
            };
        case SuperAdminConstants.EDIT_REVIEW_QUESTIONS_ERROR:
            return {
                editReviewQuestionsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ReviewQuestions/editReviewQuestions.reducer.js